import axios from "axios";

const API = axios.create({
  baseURL: "https://api.scoriva.net/api", // portunu düz yaz
});

export const productApi = {
  getAll: () => API.get("/products"),
  get: (id) => API.get(`/products/${id}`),

  create: (formData) =>
    API.post("/products", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  update: (id, formData) =>
    API.put(`/products/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  remove: (id) => API.delete(`/products/${id}`),

  getImageUrl: (id) => `${API.defaults.baseURL}/products/${id}/image`,
};
